import type { Artwork } from '../artwork';
import type { ContentKind } from '../content-descriptor/ContentKind';
import type { Page, PageHeader, PageScreenType } from '../page';
import type { ActionModel } from '@jet/environment';

export interface SearchPage extends Page {
    kind: 'SearchPage';
    term?: string;
    header: PageHeader;
    primaryButton?: ActionModel;
    screenId: string;
    screenType: PageScreenType;
    // secondaryButtons?: ActionModel[];
}

export interface SearchSuggestionLockup {
    displayTerm: string;
    title: string;
    subtitle: string;
    headline?: string;
    segue: ActionModel;
    artwork: Artwork;
    type: ContentKind;
}

export interface SearchSuggestions extends Page {
    kind: 'SearchSuggestions';
    items: SearchSuggestionLockup[];
}

export const isSearchPage = (page: Page): page is SearchPage => {
    return page.kind === 'SearchPage';
};
